<template>
  <div>
    <el-form :inline="true">
      <el-button
        type="primary"
        size="small"
        v-waves
        @click="handleAdd"
        style="margin-right: 20px"
        class="addBtn"
      >新增</el-button>
      <!-- <el-form-item label="主办方:" style="margin: 0px 20px 0 0" size="small">
        <el-select v-model="listQuery.exhibitionID" placeholder="请选择">
          <div v-for="(item, index) in exhibitionHall" :key="index">
            <el-option :label="item.exhibitName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>

      <el-button
        type="primary"
        @click="search"
        size="small"
        v-waves
        style="margin: 0 0px 10 0"
        class="addBtn"
      >搜索</el-button> -->
    </el-form>

    <div class="tableList">
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="activeImg" slot-scope="{ row }">
          <el-image class="elImage" :src="row.activeImg" :preview-src-list="[row.activeImg]"></el-image>
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-tag type="danger" effect="dark" size="mini" v-if="row.status === 1">隐藏</el-tag>
          <el-tag type="success" effect="dark" size="mini" v-else>显示</el-tag>
        </template>

        <template slot="disable" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.disable == 1">跳转</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>不跳转</el-tag>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button class="editBtn" size="mini" type="text" @click="handleEdit(row)" primary>编辑</el-button>
            <el-button
              class="editBtn"
              size="mini"
              type="text"
              @click="handleEdit(row, 1)"
              primary
            >配色(必填)</el-button>
            <!-- <el-button
              class="editBtn"
              size="mini"
              type="text"
              @click="handleCreateCode(row)"
              primary
            >生成二维码</el-button> -->
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 表单弹窗 -->
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <div style="overflow-y: auto">
        <el-form ref="form" :model="dialogForm" label-width="150px">
          <!-- <el-form-item label="主办方" required>
            <el-select v-model="dialogForm.exhibitionID" placeholder="请选择" clearable>
              <div v-for="(item, index) in exhibitionHall" :key="index">
                <el-option :label="item.exhibitName" :value="item.id + ''"></el-option>
              </div>
            </el-select>
          </el-form-item> -->

          <el-form-item label="出诊名称" required>
            <el-input clearable v-model="dialogForm.activeName" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="海报" required>
            <div v-if="dialogForm.activeImg" style="margin-top: 10px">
              <img
                :src="dialogForm.activeImg"
                alt="Uploaded Image"
                style="
                  max-width: 100%;
                  height: auto;
                  max-height: 200px;
                  margin-bottom: 10px;
                "
              />
            </div>
            <el-input clearable v-model="dialogForm.activeImg" placeholder="图片地址"></el-input>
            <el-upload
              name="formData"
              class="upload-demo"
              :action="action"
              :on-success="(response) => handleSuccess(response)"
              multiple
              :limit="1"
              :file-list="fileList"
            >
              <el-button
                class="addBtn uploadPic"
                size="mini"
                type="primary"
                style="padding: 9px 5px"
              >上传图片</el-button>
              <div slot="tip" class="tip">请上传jpg，png格式</div>
            </el-upload>
          </el-form-item>

          <el-form-item label="出诊介绍" required>
            <el-input
              clearable
              v-model="dialogForm.activeMessage"
              placeholder="请输入"
              type="textarea"
              :rows="5"
            ></el-input>
          </el-form-item>

          <el-form-item label="窗口位置">
            <el-input clearable v-model="dialogForm.addressMsg" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="出诊配置" required>
            <div
              v-for="(ticket, index) in dialogForm.ticketConfig"
              :key="index"
              style="display: flex; align-items: center"
            >
              <el-input
                v-model="ticket.name"
                placeholder="出诊时间"
                style="width: 150px; margin-right: 10px; margin-top: 10px"
              ></el-input>
              <!-- <el-input
                v-model="ticket.price"
                placeholder="挂号价"
                type="number"
                style="width: 100px; margin-right: 10px; margin-top: 10px"
                @input="ticket.price = 0"
              ></el-input>-->

              <el-input
                v-model="ticket.maxPeopes"
                placeholder="可预约数量,默认不限"
                type="number"
                style="width: 250px; margin-right: 10px; margin-top: 10px"
              ></el-input>
              <el-button
                class="cancelBtn"
                type="danger"
                @click="removeTicketType(index)"
                style="margin-right: 10px; margin-top: 10px"
              >删除</el-button>
            </div>
            <el-button
              class="addBtn"
              type="primary"
              @click="addTicketType"
              style="margin-top: 10px"
            >+ 添加</el-button>
            <!-- <div class="note">目前仅支持免费预约，如需收费预约或售票请通过服务号与我们联系。</div> -->
          </el-form-item>

          <el-form-item label="开始日期" required>
            <el-date-picker
              v-model="dialogForm.startTime"
              type="date"
              placeholder="选择开始日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              @change="handleStartTimeChange"
            ></el-date-picker>
          </el-form-item>
          <!-- 限制最长相差30天 -->
          <el-form-item label="结束日期" required>
            <el-date-picker
              v-model="dialogForm.endTime"
              type="date"
              placeholder="选择结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              :picker-options="endDateOptions"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="每周休息日">
            <el-select v-model="dialogForm.selectedWeekday" placeholder="请选择星期" clearable>
              <el-option label="星期一" value="1"></el-option>
              <el-option label="星期二" value="2"></el-option>
              <el-option label="星期三" value="3"></el-option>
              <el-option label="星期四" value="4"></el-option>
              <el-option label="星期五" value="5"></el-option>
              <el-option label="星期六" value="6"></el-option>
              <el-option label="星期日" value="0"></el-option>
            </el-select>
            <el-button
              type="primary"
              @click="calculateClosedDates"
              size="small"
              class="addBtn"
              style="margin-left: 10px"
            >同步到休息日</el-button>
            <el-button
              type="default"
              @click="resetClosedWeekdayDates"
              size="small"
              v-waves
              style="margin-left: 10px"
              class="cancelBtn"
            >重置该休息日</el-button>
            <div class="note">该值非固定值，选择星期后同步所有该星期至下方日历。在“全部休息日”的日历中您可以继续编辑。</div>
          </el-form-item>

          <el-form-item label="全部休息日">
            <el-date-picker
              style="width: 100%"
              v-model="dialogForm.closedDates"
              type="dates"
              placeholder="编辑全部休息日"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              :picker-options="closedDatesOptions"
            ></el-date-picker>
            <div class="note">设置过多休息日可能会报错，遇到该情况请缩短出诊时间，分批开放预约。</div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button class="addBtn" size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 表单弹窗 -->
    <el-dialog :title="dialogName" :visible.sync="dialogColorVisible" :close-on-click-modal="false">
      <el-form
        ref="form"
        :model="dialogForm"
        label-width="160px"
        style="display: flex; flex-wrap: nowrap"
      >
        <div>
          <el-form-item label="主背景色">
            <el-color-picker v-model="dialogForm.color1"></el-color-picker>
          </el-form-item>
          <el-form-item label="副背景色">
            <el-color-picker v-model="dialogForm.color3"></el-color-picker>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="主字体色">
            <el-color-picker v-model="dialogForm.color2"></el-color-picker>
          </el-form-item>

          <el-form-item label="副字体色">
            <el-color-picker v-model="dialogForm.color4"></el-color-picker>
          </el-form-item>
        </div>
      </el-form>
      <div class="note">！！！！！“主字体色”如不填写会导致二维码呈白色，如无特殊偏好请选择黑色。</div>
      <div class="note">！！！！！如无特殊偏好，推荐使用以下配色：</div>
      <div class="note">
        ！！！！！主背景色：#F1D7DD 主字体色：#313238 副背景色：#FFFFFF
        副字体色：#313238
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogColorVisible = false">取 消</el-button>
        <el-button class="addBtn" size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import { mapState } from "vuex";
import { IP } from "@/services/config.js";
import {
  selectApi,
  deleteApi,
  updateApi,
  addApi
} from "@/services/information/list";
// import { selectexhibitionHall } from "@/services/exhibition/exhibitionHall";
import { getNowDate } from "@/utils/tool";
export default {
  components: {
    ElTable
  },
  async created() {
    // const { data, code } = await selectexhibitionHall({
    //   pageNumber: 1,
    //   pageSize: 10,
    //   total: 0,
    //   name: "",
    //   createUserPhone:
    //     this.userInfo.group_id !== 1 ? this.userInfo.phone_number : ""
    // });
    // if (code === 200) {
    //   this.exhibitionHall = data;
    // }
    this.getListData();
  },
  data() {
    return {
      exhibitionHall: [],
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: "",
        exhibitionID: ""
      },
      tableData: [],
      dialogName: "",
      dialogVisible: false,
      dialogForm: {
        exhibitionID: "",
        activeName: "",
        activeImg: "",
        activeMessage: "",
        ticketConfig: [],
        addressMsg: "",
        startTime: "",
        endTime: "",
        closedDates: [] // Only keep relevant fields
      },
      endDateOptions: {
        disabledDate: date => {
          if (!this.dialogForm.startTime) {
            return false;
          }
          // Disable dates before the selected start date
          return date.getTime() < new Date(this.dialogForm.startTime).getTime();
        }
      },
      closedDatesOptions: {
        disabledDate: date => {
          const startTime = new Date(this.dialogForm.startTime);
          const endTime = new Date(this.dialogForm.endTime);

          // Disable dates outside of the selected start and end date range
          if (!startTime || !endTime) {
            return false;
          }
          return (
            date.getTime() < startTime.getTime() ||
            date.getTime() > endTime.getTime()
          );
        }
      },
      dateRange: [], // Array to store the start and end date
      statusList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" }
      ],
      disableList: [
        { id: 0, name: "不跳转" },
        { id: 1, name: "跳转" }
      ],
      dialogColorVisible: false
    };
  },

  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo"])
  },
  methods: {
    handleStartTimeChange() {
      // If end date is earlier than the start date, reset the end date
      if (
        this.dialogForm.endTime &&
        new Date(this.dialogForm.endTime).getTime() <
          new Date(this.dialogForm.startTime).getTime()
      ) {
        this.dialogForm.endTime = "";
      }
    },
    resetClosedWeekdayDates() {
      const selectedWeekday = this.dialogForm.selectedWeekday;

      if (selectedWeekday === null) {
        this.$message.error("没有选择任何星期需要重置");
        return;
      }

      const startDate = new Date(this.dialogForm.startTime);
      const endDate = new Date(this.dialogForm.endTime);

      if (!startDate || !endDate) {
        this.$message.error("请先选择开始日期和结束日期");
        return;
      }

      // Ensure closedDates is an array, or initialize it as an empty array if it's null or undefined
      const closedDates = Array.isArray(this.dialogForm.closedDates)
        ? this.dialogForm.closedDates
        : [];

      // Filter out the closed dates that match the selected weekday
      const filteredClosedDates = closedDates.filter(date => {
        const currentDate = new Date(date);
        return currentDate.getDay() !== parseInt(selectedWeekday);
      });

      // Update closedDates and reset the selectedWeekday
      this.dialogForm.closedDates = filteredClosedDates;
      this.dialogForm.selectedWeekday = null; // Reset the selected weekday

      this.$message.success("已成功重置星期和相关的不可购票日期");
    },
    calculateClosedDates() {
      const startDate = new Date(this.dialogForm.startTime);
      const endDate = new Date(this.dialogForm.endTime);
      const selectedWeekday = this.dialogForm.selectedWeekday;

      if (!startDate || !endDate || selectedWeekday === undefined) {
        this.$message.error("请先选择开始日期, 结束日期 和 每周休息日");
        return;
      }

      // Initialize closedDates as an array if it's not already one
      let closedDates = Array.isArray(this.dialogForm.closedDates)
        ? [...this.dialogForm.closedDates]
        : [];

      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        if (currentDate.getDay() === parseInt(selectedWeekday)) {
          closedDates.push(currentDate.toISOString().slice(0, 10)); // Format as 'YYYY-MM-DD'
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      this.dialogForm.closedDates = [...new Set(closedDates)]; // Remove duplicates

      this.$message.success("已成功添加不允许预约日期"); //TODO:若点清空此处判断存在问题
    },
    async getListData(listQuery) {
      // if (this.userInfo.group_id !== 1) {
      //   this.listQuery.exhibitionID = this.exhibitionHall[0]?.id || null;
      // }
      this.loading = true;
      const { data, code, count } = await selectApi(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    search() {
      this.getListData();
    },
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },
    handleAdd() {
      //判断账号是否已过期进行拦截
      if (this.userInfo.useTime < getNowDate()) {
        this.$message.error("您的账号已过期,请前往小程序端续费!");
        localStorage.setItem("storeToken", null);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        return;
      }
      // if (this.exhibitionHall.length === 0) {
      //   this.$message.error("请先创建主办方信息");
      //   return;
      // }
      this.dialogVisible = true;
      this.dialogName = "创建";
      this.dialogForm = {
        exhibitionID: "",
        activeName: "",
        activeImg: "",
        activeMessage: "",
        ticketConfig: [],
        addressMsg: "",
        startTime: "",
        endTime: "",
        closedDates: []
      };
      this.dateRange = [];
    },

    handleEdit(row, type) {
      if (type === 1) {
        this.dialogColorVisible = true;
        this.dialogName = "门票UI色值编辑";
      } else {
        this.dialogVisible = true;
        this.dialogName = "编辑";
      }

      // Clone the row data to avoid direct mutation
      this.dialogForm = JSON.parse(JSON.stringify(row));

      // If ticketConfig is stored as a string, parse it to a JavaScript array
      if (typeof this.dialogForm.ticketConfig === "string") {
        try {
          this.dialogForm.ticketConfig = JSON.parse(
            this.dialogForm.ticketConfig
          );
        } catch (error) {
          console.error("Failed to parse ticketConfig:", error);
          this.dialogForm.ticketConfig = [];
        }
      }

      // Ensure ticketConfig is an array
      if (!Array.isArray(this.dialogForm.ticketConfig)) {
        this.dialogForm.ticketConfig = [];
      }

      // Convert the closedDates string back into an array if it is stored as a string
      if (
        this.dialogForm.closedDates &&
        typeof this.dialogForm.closedDates === "string"
      ) {
        this.dialogForm.closedDates = this.dialogForm.closedDates.split(",");
      }

      // Ensure closedDates is an array
      if (!Array.isArray(this.dialogForm.closedDates)) {
        this.dialogForm.closedDates = [];
      }

      // Initialize dateRange with start and end dates if they exist
      this.dateRange = [this.dialogForm.startTime, this.dialogForm.endTime];
    },
    handleSuccess(e) {
      this.dialogForm.activeImg = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },

    save() {
      this.dialogForm.exhibitionID=this.userInfo.id;
      // Validate required fields
      if (
        !this.dialogForm.exhibitionID ||
        !this.dialogForm.activeName ||
        !this.dialogForm.activeImg ||
        !this.dialogForm.startTime ||
        !this.dialogForm.endTime
      ) {
        this.$message.error("请填写所有必填字段");
        return;
      }

      // Validate ticketConfig array
      for (let i = 0; i < this.dialogForm.ticketConfig.length; i++) {
        let ticket = this.dialogForm.ticketConfig[i];
        ticket.price = 0; //挂号价填充为0
        // Check if 出诊名称名称 is empty
        if (!ticket.name) {
          this.$message.error(`出诊名称名称不能为空 (第 ${i + 1} 项)`);
          return;
        }

        // Check if 挂号价 is empty or not a valid number
        console.log('ticket',ticket)
        if (
          ticket.price === "" ||
          ticket.price === null ||
          ticket.price === undefined
        ) {
          this.$message.error(`挂号价不能为空 (第 ${i + 1} 项)`);
          return;
        }

        // Check if 挂号价 is lower than 0
        if (parseFloat(ticket.price) < 0) {
          this.$message.error(`挂号价不能小于 0 (第 ${i + 1} 项)`);
          return;
        }

        // Check if 数量 is a valid number (if provided)
        if (ticket.maxPeopes && isNaN(ticket.maxPeopes)) {
          this.$message.error(`数量必须是有效数字 (第 ${i + 1} 项)`);
          return;
        }

        // Check if 数量 is lower than 0 (if provided)
        if (ticket.maxPeopes && parseInt(ticket.maxPeopes) < 0) {
          this.$message.error(`数量不能小于 0 (第 ${i + 1} 项)`);
          return;
        }
      }

      // Ensure closedDates is an array; if not, initialize it as an empty array
      const closedDatesArray = Array.isArray(this.dialogForm.closedDates)
        ? this.dialogForm.closedDates
        : [];

      // Join the closedDates array into a comma-separated string
      const closedDatesStr = closedDatesArray.join(",");

      // Prepare the data object to be saved
      const saveData = {
        ...this.dialogForm,
        closedDates: closedDatesStr, // Save closedDates as a comma-separated string
        createPhone: this.userInfo.phone_number,
        ticketConfig: JSON.stringify(this.dialogForm.ticketConfig) // Serialize ticketConfig
      };

      // Ensure `selectedWeekday` is not included in saveData
      delete saveData.selectedWeekday; // Remove it from the payload

      // Check if creating a new entry or updating an existing one
      if (!this.dialogForm?.id) {
        // Add a new entry
        addApi(saveData).then(res => {
          if (res.code === 200) {
            this.$message.success("创建成功!");
            this.dialogVisible = false;
            this.getListData();
          } else {
            this.$message.error("创建失败，请重试");
          }
        });
      } else {
        // Update an existing entry
        updateApi(saveData).then(res => {
          if (res.code === 200) {
            this.$message.success("编辑成功!");
            this.dialogVisible = false;
            this.getListData();
          } else {
            this.$message.error("编辑失败，请重试");
          }
        });
      }
    },

    handleCreateCode(row) {
      // getCodeExhibitioneCode({ id: row.id }).then(res => {
      //   if (res.code === 200) {
      //     this.$message({
      //       type: "success",
      //       message: "创建成功,前往下载!"
      //     });
      //     this.dialogCodeVisible = false;
      //     setTimeout(() => {
      //       window.open(res.data, "_blank");
      //     }, 1000);
      //   }
      // });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },
    addTicketType() {
      this.dialogForm.ticketConfig.push({ name: "", price: "" });
    },
    removeTicketType(index) {
      this.dialogForm.ticketConfig.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="less">
.selectForm {
  background: #fff;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
.note {
  font-size: 0.8em;
  color: #b95c5c;
}
</style>
